import { z } from "zod";

// Zod compiles object parsers with `new Function` after probing for it, and a strict content
// security policy reports even the caught probe (openspec change content-security-policy).
// Object schemas read this when they are built, so the SPA entry imports this module first.
z.config({ jitless: true });
